/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StartCount/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2MedicalReportClipboard from 'DesignSystem/Svgs/Tysiav2MedicalReportClipboard/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StartCount({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/SlotsPopover/DateAndMetrics/StartCount"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let calendarDayStartsValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'starts',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let calendarDayStartsValueData1 = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'starts',
})
let constantData = 1
let aggregateData = fromAggregate.equals(calendarDayStartsValueData1, constantData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="StartCount.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-stfqD': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="StartCount.Vertical"
  data-view-path={viewPath}
 style={{'--pl-2-stfqD': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pr-3-stfqD': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pt-4-stfqD': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pb-5-stfqD': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2MedicalReportClipboard
  viewPath={`${viewPath}/Tysiav2MedicalReportClipboard`}
 width={16}
 height={14}
 fill2={dtColorsNeutral400}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="calendar_day.starts"
 text={calendarDayStartsValueData}
 color={dtColorsNeutral900}
 size="small"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 size="small"
 text={aggregateData ? "Start" : "Starts"}
 data="calendar_day.starts"
 data={1}
 aggregate="/Simple/Data/aggregate equals"
/>
</div>
{children}
</React.Fragment>)
}